module.exports = __webpack_public_path__ + "78a48a3743efa2a86b1210e601805ddd.woff";